module.exports = __webpack_public_path__ + "img/icon_box_1_1.cc92e4ca.png";